

































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import * as service from '@/services/prescription';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop } from 'vue-property-decorator';
import { BolsaMulticompartPrescricaoDTO } from '../../interfaces/prescription';
import * as resize from "@/subjects/resize";

@Component({
  components: {
    GChart,
    ListMessages,
  },
})
export default class BagModelPrescription extends BaseComponent {
  @Prop()
  public open: any;

  @Prop()
  public id: number;

  private ml: number = 0;

  private chartData = [];

  private loading = false;
  private error = false;

  private bolsas: BolsaMulticompartPrescricaoDTO[] = [];

  private activeTab = '';

  private vertical = resize.isXsOrSmSizeScreen();

  private chartOptions = {
    //width: 800,
    height: 250,
    isStacked: true,
    //bar: { groupWidth: '80%' },
    legend: { position: 'right', textStyle: { fontSize: 10 } },
    is3D: true,
    chartArea: { right: 300, top: 10, bottom: 20, left: 30 },
    vAxis: { textStyle: { fontSize: 11, bold: true } },
    hAxis: { textStyle: { fontSize: 9 }, format: '####.## mL' },
    // chartArea: {'width': '100%', 'height': '95%'},
    //chartArea:{left:50,top:20,width:'90%',height:'90%'}
  };

  private chartOptionsVertical = {
    //width: 800,
    height: 450,
    isStacked: true,
    //bar: { groupWidth: '80%' },
    legend: { position: 'top', textStyle: { fontSize: 10 }, maxLines: 5},
    is3D: true,
    chartArea: { right: 10, top: 100, bottom: 30, left: 30 },
    vAxis: { textStyle: { fontSize: 11, bold: true } },
    hAxis: { textStyle: { fontSize: 9 }, format: '####.## mL' },
    // chartArea: {'width': '100%', 'height': '95%'},
    //chartArea:{left:50,top:20,width:'90%',height:'90%'}
  };

  mounted() {
    this.buscarDadosBolsas();
  }

  buscarDadosBolsas() {
    this.loading = true;
    this.error = false;

    this.addSubsc(
      service.getBolsasMulticompartDetalhe(this.id).subscribe(
        (result) => {
          this.loading = false;
          this.error = false;
          this.bolsas = result;
          this.bolsas.forEach((b) => {
            this.chartData.push(this.getData(b));
          });
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  getData(bolsa: BolsaMulticompartPrescricaoDTO) {
    let data = [];
    let produtos = ['Compartimento'];
    let agua = null;
    bolsa.produtos.sort((o1, o2) => {
      if (o1.letraCompart == o2.letraCompart) {
        return 0;
      }
      return o1.letraCompart > o2.letraCompart ? 1 : -1;
    });
    data.push(produtos);
    let compart = [];

    let letraAtual = null;
    bolsa.produtos.forEach((d) => {
      if (!produtos.find((f) => f == d.nomeProduto)) {
        if (d.agua) {
          agua = d.nomeProduto;
        } else {
          produtos.push(d.nomeProduto);
        }
      }
    });

    produtos.push(agua);

    bolsa.produtos.forEach((d) => {
      if (letraAtual != d.letraCompart) {
        compart = [];
        compart.push(d.letraCompart);
        letraAtual = d.letraCompart;
        data.push(compart);
      }
      compart[produtos.indexOf(d.nomeProduto)] = d.quantidade;
    });
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[0].length; j++) {
        if (!data[i][j]) {
          data[i][j] = null;
        }
      }
    }

    return data;
  }

  /*

  private distribuicao = [
    {
      idProduto: 229,
      codProduto: 'AAA10',
      nomeProduto: 'Aminoácidos Totais a 10% Adulto PRT',
      idCompartimento: 10,
      letraCompart: 'A',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 548.0,
      agua: false,
    },
    {
      idProduto: 248,
      codProduto: 'CAL1046',
      nomeProduto: 'Gluconato de Cálcio a 10% (0,46 mEq/mL)',
      idCompartimento: 10,
      letraCompart: 'A',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 17.0,
      agua: false,
    },
    {
      idProduto: 247,
      codProduto: 'AGUABID',
      nomeProduto: 'Água para Injetáveis',
      idCompartimento: 10,
      letraCompart: 'A',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 30.222929936305732,
      agua: true,
    },
    {
      idProduto: 261,
      codProduto: 'POTCL19',
      nomeProduto: 'Cloreto de Potássio a 19,1% (2,56 mEq/mL)',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 10.0,
      agua: false,
    },
    {
      idProduto: 264,
      codProduto: 'SODCL20',
      nomeProduto: 'Cloreto de Sódio a 20% (3,42 mEq/mL)',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 20.0,
      agua: false,
    },
    {
      idProduto: 262,
      codProduto: 'POTF2M',
      nomeProduto: 'Fosfatos de Potássio (K+: 2 mEq/mL; PO4-3: 1,1 mmol/mL)',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 12.0,
      agua: false,
    },
    {
      idProduto: 245,
      codProduto: 'GLI50',
      nomeProduto: 'Glicose Monoidratada a 50%',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 473.0,
      agua: false,
    },
    {
      idProduto: 255,
      codProduto: 'OLI4',
      nomeProduto: 'Oligoelementos Adulto (acima de 10 kg)',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 5.0,
      agua: false,
    },
    {
      idProduto: 254,
      codProduto: 'MAGS10',
      nomeProduto: 'Sulfato de Magnésio a 10% (0,81 mEq/mL)',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 7.0,
      agua: false,
    },
    {
      idProduto: 247,
      codProduto: 'AGUABID',
      nomeProduto: 'Água para Injetáveis',
      idCompartimento: 11,
      letraCompart: 'B',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 40.8343949044586,
      agua: true,
    },
    {
      idProduto: 237,
      codProduto: 'LIPSO20',
      nomeProduto: 'Emulsão Lipídica Soja/TCM/Oliva/Peixe a 20%',
      idCompartimento: 12,
      letraCompart: 'C',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 157.0,
      agua: false,
    },
    {
      idProduto: 240,
      codProduto: 'LIPP10',
      nomeProduto: 'Emulsão Lipídica Óleo de Peixe a 10%',
      idCompartimento: 12,
      letraCompart: 'C',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 35.0,
      agua: false,
    },
    {
      idProduto: 270,
      codProduto: 'VITTRAA',
      nomeProduto: 'Polivitamínico A Adulto (VITK)',
      idCompartimento: 12,
      letraCompart: 'C',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 5.0,
      agua: false,
    },
    {
      idProduto: 247,
      codProduto: 'AGUABID',
      nomeProduto: 'Água para Injetáveis',
      idCompartimento: 12,
      letraCompart: 'C',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 39.94267515923567,
      agua: true,
    },
    {
      idProduto: 269,
      codProduto: 'VITTRAB',
      nomeProduto: 'Polivitamínico B Adulto',
      idCompartimento: 13,
      letraCompart: 'D',
      idModelo: 2,
      codigoModelo: 'ARFA45',
      quantidade: 5.0,
      agua: false,
    },
  ];
  */
}
